import React from "react";

const dinheiro = (v) => `R$ ${Number(v || 0).toFixed(2).replace(".", ",")}`;

// Fim da comanda do celular quando parte da mesa já foi paga (no caixa ou
// pelo celular): total, o que já foi pago e o que falta (dono, 24/09/2026 —
// igual ao rodapé da comanda do painel). Sem pagamento, não aparece.
export default function ResumoPagoComanda({ comanda, darkMode }) {
  if (!(comanda?.ja_pago > 0)) return null;
  const borda = darkMode ? "border-zinc-800 bg-zinc-900" : "border-zinc-200 bg-white";
  return (
    <div className={`rounded-2xl border px-4 py-3 space-y-1 text-sm ${borda}`} data-e2e="mesa-resumo-pago">
      <div className="flex justify-between opacity-70">
        <span>Total da mesa</span>
        <span className="font-semibold">{dinheiro(comanda.total)}</span>
      </div>
      <div className="flex justify-between text-emerald-500 font-semibold">
        <span>Pago</span>
        <span>− {dinheiro(comanda.ja_pago)}</span>
      </div>
      <div className="flex justify-between font-black text-base">
        <span>Falta pagar</span>
        <span data-e2e="mesa-resumo-falta">{dinheiro(comanda.restante)}</span>
      </div>
    </div>
  );
}
